import React, {useEffect, useState} from 'react'
import axios from 'axios'
import LoadingOverlay from 'react-loading-overlay'
import './MiPerfil.css'

const emptyPasswords = {currentPassword: '', newPassword: '', confirmPassword: ''}
const generalFields = [
  ['Régimen fiscal', 'regimenFiscal'], ['Nombre comercial', 'nombreComercial'],
  ['Razón social', 'razonSocial'], ['RFC', 'rfc'], ['CURP', 'curp'],
  ['Nombre de contacto', 'nombreContacto'], ['Teléfono', 'telefono'], ['Celular', 'celular'],
  ['Correo electrónico', 'email'], ['Calle', 'calle'], ['No. exterior', 'exterior'],
  ['No. interior', 'interior'], ['Colonia', 'colonia'], ['Código postal', 'codigoPostal'],
  ['Delegación / municipio', 'municipio'], ['Estado', 'estado'], ['País', 'pais'],
]
const commercialFields = [
  ['Vendedor asignado', 'vendedor'], ['Lista de precios', 'listaPrecios'],
  ['Días de crédito', 'diasCredito'], ['Cascada de descuentos', 'cascadaDescuentos'],
  ['Condicionado 1', 'condicionado1', '%'], ['Condición 1', 'condicion1'],
  ['Condicionado 2', 'condicionado2', '%'], ['Condición 2', 'condicion2'],
  ['Descuento total', 'descuentoTotal', '%'],
]

const displayValue = (value, suffix = '') => {
  if (value === null || value === undefined || value === '') return 'No disponible'
  return `${value}${suffix}`
}

function MiPerfil() {
  const API_URL = process.env.REACT_APP_API_URL
  const [profile, setProfile] = useState(null)
  const [passwords, setPasswords] = useState(emptyPasswords)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState(null)

  useEffect(() => {
    axios.get(`${API_URL}/mi-perfil`)
      .then(({data}) => setProfile(data.data))
      .catch((error) => setMessage({type: 'danger', text: error.response?.data?.message || 'No fue posible cargar tu perfil.'}))
      .finally(() => setLoading(false))
  }, [API_URL])

  const updatePasswordField = (event) => {
    setPasswords({...passwords, [event.target.name]: event.target.value})
    if (message?.scope === 'password') setMessage(null)
  }

  const changePassword = async (event) => {
    event.preventDefault()
    setMessage(null)
    if (passwords.newPassword.length < 8) {
      setMessage({scope: 'password', type: 'danger', text: 'La nueva contraseña debe tener al menos 8 caracteres.'})
      return
    }
    if (passwords.newPassword !== passwords.confirmPassword) {
      setMessage({scope: 'password', type: 'danger', text: 'La nueva contraseña y su confirmación no coinciden.'})
      return
    }
    setSaving(true)
    try {
      const {data} = await axios.put(`${API_URL}/mi-perfil-password`, passwords)
      setPasswords(emptyPasswords)
      setMessage({scope: 'password', type: 'success', text: data.message})
    } catch (error) {
      setMessage({scope: 'password', type: 'danger', text: error.response?.data?.message || 'No fue posible actualizar la contraseña.'})
    } finally {
      setSaving(false)
    }
  }

  return (
    <LoadingOverlay active={loading} spinner text='Cargando perfil...'>
      <div className='mi-perfil-page'>
        <header className='mi-perfil-header'>
          <div><h1>Mi Perfil</h1><p>Consulta tu información registrada y tus condiciones comerciales.</p></div>
        </header>

        {message && message.scope !== 'password' && <div className={`alert alert-${message.type}`}>{message.text}</div>}
        {profile && <>
          <section className='mi-perfil-section'>
            <h2>Información general</h2>
            <div className='mi-perfil-grid'>
              {generalFields.map(([label, field]) => <div className={`mi-perfil-field ${field === 'regimenFiscal' ? 'mi-perfil-field-wide' : ''}`} key={field}>
                <span>{label}</span><strong>{displayValue(profile.general[field])}</strong>
              </div>)}
            </div>
          </section>

          <section className='mi-perfil-section'>
            <h2>Información comercial</h2>
            <div className='mi-perfil-grid'>
              {commercialFields.map(([label, field, suffix]) => <div className='mi-perfil-field' key={field}>
                <span>{label}</span><strong>{displayValue(profile.commercial[field], suffix)}</strong>
              </div>)}
            </div>
          </section>
        </>}

        <section className='mi-perfil-section mi-perfil-password'>
          <div className='mi-perfil-password-title'><h2>Cambiar contraseña</h2><p>Por seguridad, confirma primero tu contraseña actual.</p></div>
          <form onSubmit={changePassword}>
            <label><span>Contraseña actual</span><input className='form-control' type='password' name='currentPassword' autoComplete='current-password' required value={passwords.currentPassword} onChange={updatePasswordField} /></label>
            <label><span>Nueva contraseña</span><input className='form-control' type='password' name='newPassword' autoComplete='new-password' minLength='8' required value={passwords.newPassword} onChange={updatePasswordField} /></label>
            <label><span>Confirmar nueva contraseña</span><input className='form-control' type='password' name='confirmPassword' autoComplete='new-password' minLength='8' required value={passwords.confirmPassword} onChange={updatePasswordField} /></label>
            {message?.scope === 'password' && <div className={`alert alert-${message.type} mi-perfil-password-message`}>{message.text}</div>}
            <div className='mi-perfil-actions'><button className='btn btn-primary' type='submit' disabled={saving}>{saving ? 'Guardando...' : 'Actualizar contraseña'}</button></div>
          </form>
        </section>
      </div>
    </LoadingOverlay>
  )
}

export {MiPerfil}
